module.exports = __webpack_public_path__ + "static/img/files.4483fb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/widget/files.png
// module id = jJZV
// module chunks = 11